export default {
  setUsersData(state, users) {
    state.users = users;
  }
}
